import Grid from '@material-ui/core/Grid'
import React, { PropsWithChildren } from 'react'
import { NavDropdownLinkCard, NavDropdownLinkCardProps } from './NavDropdownLinkCard'
import { NavDropdownLinkItem, NavDropdownLinkItemProps } from './NavDropdownLinkItem'
import { StyledNavDropdownLinksContainer } from './styledNavDropdownLinkCard'

export type NavDropdownLinksProps =  (
  | ({ card?: false; item?: false } & Omit<React.ComponentProps<typeof Grid>, 'direction'|'justifyContent'|'alignItems'|'container'|'wrap'>)
  | ({ card: true; item?: false } & NavDropdownLinkCardProps)
  | ({ card?: false; item?: true } & NavDropdownLinkItemProps)
)

export const NavDropdownLinks: React.FC<PropsWithChildren<NavDropdownLinksProps>> = ({ card, item, ...props }) => {
  if (card) {
    return <NavDropdownLinkCard { ...props as NavDropdownLinkCardProps} />
  }

  if (item) {
    return <NavDropdownLinkItem { ...props as NavDropdownLinkItemProps} />
  }

  return (
    <StyledNavDropdownLinksContainer container direction="row" justifyContent="flex-start" wrap="nowrap" {...props} />
  )
}
